// extracted by mini-css-extract-plugin
module.exports = {"CenterLayout":"CenterLayout__lhCKD","medium":"medium__2OpMA","small":"small__3kcYH"};